export default {
  models: {
    site: {
      user: 'utilisateur',
    },
    attributes: {
      site: {
        user: {
          email: null,
          active: 'actif',
        },
      },
    },
  },
};
